import React, { Component } from "react";
import * as Yup from "yup";
import _ from "lodash";
import FormGrid, { FormGridField } from "./FormGrid";
import FormWrapper from "./FormWrapper";
import { FormUtils } from "..";

export interface FormProps {
    fields: FormGridField[];
    initialValues?: any;
    onChange: (...args: any) => any;
}

export interface FormState {
    fields: FormGridField[];
    validation: Yup.Schema<any>;
}

class FormSelect extends Component<FormProps, FormState> {
    constructor(props) {
        super(props);

        this.state = {
            fields: this.props.fields.map(field => ({
                ...field,
                key: _.uniqueId()
            })),
            validation: FormSelect.generateValidator(this.props.fields)
        };
    }

    static generateValidator(fields: FormGridField[]): Yup.Schema<any> {
        return Yup.object().shape(
            fields.reduce((accumulator, field) => {
                return {
                    ...accumulator,
                    [field.name]: field.validationSchema
                        ? FormUtils.generateYupValidatorFromSchema(
                            field.validationSchema
                        )
                        : field.validation
                };
            }, {})
        );
    }

    onChange = ({ values, isValid }) => {
        this.props.onChange({
            values,
            isValid
        });
    };

    renderFields(fields) {
        return <FormGrid fields={fields} />;
    }

    static getDerivedStateFromProps(props: FormProps, state) {
        const prevFieldsNames = props.fields.map(
            field => field.fieldOptions.id
        );

        const currentFieldsNames = state.fields.map(
            field => field.fieldOptions.id
        );

        const selectElement = _.find(props.fields, { fieldType: "select" });

        if (
            !_.isEqual(prevFieldsNames, currentFieldsNames) &&
            selectElement == undefined
        ) {
            return {
                fields: props.fields.map(field => ({
                    ...field,
                    key: field.key || _.uniqueId()
                })),
                validation: FormSelect.generateValidator(props.fields)
            };
        } else if (selectElement !== undefined) {
            return {
                fields: props.fields.map(field => {
                    if (field.fieldType == "select") {
                        const previous = _.find(state.fields, {
                            name: field.name
                        });

                        if (
                            previous !== undefined &&
                            field.fieldOptions["items"].length !=
                            previous.fieldOptions["items"].length
                        ) {
                            return {
                                ...field,
                                key: _.uniqueId()
                            };
                        }
                    }
                    return {
                        ...field,
                        key: field.key || _.uniqueId()
                    };
                }),
                validation: FormSelect.generateValidator(props.fields)
            };
        }

        return null;
    }

    render() {
        return (
            <FormWrapper
                initialValues={this.props.initialValues || {}}
                onChange={this.onChange}
                validation={this.state.validation}
                fields={this.state.fields}
            >
                {this.renderFields(this.state.fields)}
            </FormWrapper>
        );
    }
}

export default FormSelect;
